import Vue from 'vue';
import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const csrfMeta = document.head.querySelector('meta[name="csrf-token"]');
if (csrfMeta) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfMeta.content;
}
if (window.app.url) {
    axios.defaults.baseURL = window.app.url;
}
if (localStorage.getItem('token')) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (axios.isCancel(error)) {
        // Request sengaja dibatalkan komponen (mis. search realtime di list
        // ticket membatalkan request lama yang tertimpa). Ini bukan error
        // jaringan — jangan tampilkan toast koneksi.
        return Promise.reject(error);
    }
    if (!error.response) {
        // Server tidak terjangkau / koneksi putus (penting di app mobile & desktop).
        Ladda.stopAll();
        Vue.notify({title: 'Koneksi', text: 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda.', type: 'error'});
        throw new Error('Network Error');
    }
    if (error.response.status === 401) {
        // Sesi berakhir: bersihkan token lalu kembali ke login.
        // Di app (mobile/desktop) redirect in-app, di web tetap full-page.
        delete window.axios.defaults.headers.common.Authorization;
        localStorage.removeItem('token');
        if (window.app && window.app.is_app) {
            import('@/views/router').then(function (module) {
                module.default.push('/auth/login');
            });
        } else {
            window.location.href = window.app.url + '/auth/login';
        }
        throw new Error('Unauthorized');
    } else if (error.response.data.message) {
        // If it is a notification error, display message
        Ladda.stopAll();
        let message = error.response.data.message;
        if (error.response.data.errors) {
            message = '<ul class="text-left">';
            Object.keys(error.response.data.errors).forEach(function (element) {
                error.response.data.errors[element].forEach(function (item) {
                    message += '<li>' + item + '</li>';
                });
            });
            message += '</ul>';
        }
        Vue.notify({title: 'Error', text: message, type: 'error'});
        throw new Error(error.response.data.message);
    } else {
        // If it is an uncontrolled error, display http status
        Ladda.stopAll();
        Vue.notify({title: 'Error ' + error.response.status, text: error.response.statusText, type: 'error'});
        throw new Error(error);
    }
});

window.axios = axios;
